<template>
  <v-row>
    <v-col cols="3">
      <club-without-coach />
    </v-col>
  </v-row>
</template>

<script>
import ClubWithoutCoach from "@/components/reporting/blocks/ClubWithoutCoach";

export default {
  name: "OperationsDashboard",
  components: { ClubWithoutCoach },
  data() {
    return {};
  },
};
</script>
